namespace Nobox {
    
    @Serenity.Decorators.registerEditor()
    export class ColorKanbanEditor extends Serenity.Select2Editor<object, object> {

        constructor(hidden: JQuery) {
            super(hidden, null);
            this.addItem({ id: "#005FB1", text: `None` });
            this.addItem({ id: "green", text: `Low` });
            this.addItem({ id: "orange", text: `Medium` });
            this.addItem({ id: "red", text: `High` });
        }

        public getSelect2Options() {
            var selec2Options = super.getSelect2Options();
            selec2Options.formatResult = this.myFormatResult;
            selec2Options.formatSelection = this.myFormatSelection;
            return selec2Options;
        }

        protected myFormatResult(item: Serenity.Select2Item) {
            return item.text;
        }

        protected myFormatSelection(item: Serenity.Select2Item): string {
            if (item === undefined)
                return null;

            return item.text;
        }
    }
}